var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeicons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20898 16.6666L10.4173 13.5416M14.584 11.4583L19.7923 8.33331M12.5007 5.20831V10.4166M12.5007 14.5833V19.7916M5.20898 8.33331L10.4173 11.4583M14.584 13.5416L19.7923 16.6666M21.3548 9.37498V15.1041M14.0632 21.3541L19.7923 18.2291M4.68815 18.2291L10.9382 21.3541M3.64648 15.625V9.37498M4.68815 6.77081L10.9382 3.64581M20.3132 6.77081L14.0632 3.64581",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.20831C13.3629 5.20831 14.0625 4.50876 14.0625 3.64581C14.0625 2.78287 13.3629 2.08331 12.5 2.08331C11.6371 2.08331 10.9375 2.78287 10.9375 3.64581C10.9375 4.50876 11.6371 5.20831 12.5 5.20831Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.9166C13.3629 22.9166 14.0625 22.2171 14.0625 21.3541C14.0625 20.4912 13.3629 19.7916 12.5 19.7916C11.6371 19.7916 10.9375 20.4912 10.9375 21.3541C10.9375 22.2171 11.6371 22.9166 12.5 22.9166Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64648 9.375C4.50943 9.375 5.20898 8.67544 5.20898 7.8125C5.20898 6.94956 4.50943 6.25 3.64648 6.25C2.78354 6.25 2.08398 6.94956 2.08398 7.8125C2.08398 8.67544 2.78354 9.375 3.64648 9.375Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3555 9.375C22.2184 9.375 22.918 8.67544 22.918 7.8125C22.918 6.94956 22.2184 6.25 21.3555 6.25C20.4925 6.25 19.793 6.94956 19.793 7.8125C19.793 8.67544 20.4925 9.375 21.3555 9.375Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3555 18.75C22.2184 18.75 22.918 18.0504 22.918 17.1875C22.918 16.3246 22.2184 15.625 21.3555 15.625C20.4925 15.625 19.793 16.3246 19.793 17.1875C19.793 18.0504 20.4925 18.75 21.3555 18.75Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64648 18.75C4.50943 18.75 5.20898 18.0504 5.20898 17.1875C5.20898 16.3246 4.50943 15.625 3.64648 15.625C2.78354 15.625 2.08398 16.3246 2.08398 17.1875C2.08398 18.0504 2.78354 18.75 3.64648 18.75Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 10.1562L14.5846 11.3281V13.6719L12.5013 14.8437L10.418 13.6719V11.3281L12.5013 10.1562Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeicons);
export default __webpack_public_path__ + "static/media/hugeicons.e1ddd605da967802cc183fb0a10f48e7.svg";
export { ForwardRef as ReactComponent };